export const HANDLE_TYPE_PRICE_LINK_LOADING = 'LINK_TABLE/HANDLE_TYPE_PRICE_LINK_LOADING';
export const SET_TYPE_PRICE_LINK = 'LINK_TABLE/SET_TYPE_PRICE_LINK';
export const SET_TYPE_PRICE_LINK_ERRORS = 'LINK_TABLE/SET_TYPE_PRICE_LINK_ERRORS';
export const CLEAR_TYPE_PRICE_LINK_ERRORS = 'LINK_TABLE/CLEAR_TYPE_PRICE_LINK_ERRORS';
